import React, { useEffect } from 'react';
import Layout from './Common/layout/index';
import * as appConfig from './Common/config/app-brand-config.json';
import commonStore from './Common/stores/commonStore';

const startup = async () => {
  commonStore.appName = appConfig.appName;
};

const App = () => {
  const perfEntries = performance.getEntriesByType('navigation');
  const perfEntryObject = perfEntries[0];
  const isPageReloaded = perfEntryObject.type === 'reload';

  useEffect(() => {
    startup();
  }, [isPageReloaded]);

  return <Layout />;
};
export default App;
